module.exports = __webpack_public_path__ + "7075b3fea8a0752260ab50225da7d25e.png";